import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

const UploadProgressBar = ({ progress }) => {
  return (
    <div className={styles.progressContainer}>
      <div style={{ width: `${progress}%` }} className={styles.activeProgress} />
    </div>
  );
};

UploadProgressBar.propTypes = {
  progress: PropTypes.number
};

UploadProgressBar.defaultProps = {
  progress: 0
};

export default UploadProgressBar;
